/** 브라우저 public 디렉터리에서 제공되는 타운카 공용 브랜드 에셋입니다. */
export const SHOWROOM_LOGO_URL = '/brand/towncar_logo.webp';
